import React from "react";
import LegalLayout from "../../components/portal/LegalLayout";

export default function PrivacyPolicyPage() {
  return (
    <LegalLayout title="Privacy Policy" updated="Effective Date: January 1, 2026">
      <p>
        At <strong>Antarctic Press</strong>, your privacy is important to us. This
        Privacy Policy explains how we collect, use, disclose, and protect
        your information when you use our platform.
      </p>

      <section>
        <h2>1. Information We Collect</h2>

        <h3>a. Personal Information</h3>
        <p>
          When you create an account, back a project, or create a campaign, we
          may collect:
        </p>
        <ul>
          <li>Name and email address</li>
          <li>Account and profile information</li>
          <li>Billing and shipping details</li>
          <li>Transaction records</li>
        </ul>

        <h3>b. Payment Information</h3>
        <p>
          Payments are processed securely through third‑party providers such
          as Stripe. Antarctic Press does not store your credit card details.
        </p>

        <h3>c. Usage Data</h3>
        <p>
          We automatically collect technical information including IP address,
          browser type, device information, and interaction data to improve
          the platform.
        </p>
      </section>

      <section>
        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>To operate and maintain the platform</li>
          <li>To process pledges and campaign activity</li>
          <li>To communicate important updates and notifications</li>
          <li>To improve platform performance and security</li>
          <li>To comply with legal obligations</li>
        </ul>
      </section>

      <section>
        <h2>3. Sharing of Information</h2>
        <p>
          We do not sell your personal information. We may share limited data
          with:
        </p>
        <ul>
          <li>Payment processors (e.g., Stripe)</li>
          <li>Project creators for reward fulfillment</li>
          <li>Service providers supporting platform operations</li>
          <li>Legal authorities when required by law</li>
        </ul>
      </section>

      <section>
        <h2>4. Cookies and Tracking</h2>
        <p>
          Antarctic Press uses cookies and similar technologies to authenticate users,
          remember preferences, and analyze site traffic. You may control
          cookie settings through your browser.
        </p>
      </section>

      <section>
        <h2>5. Data Security</h2>
        <p>
          We implement reasonable administrative, technical, and physical
          safeguards to protect your data. However, no system can be 100%
          secure.
        </p>
      </section>

      <section>
        <h2>6. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access and update your personal information</li>
          <li>Request account deletion</li>
          <li>Opt out of non‑essential communications</li>
        </ul>
      </section>

      <section>
        <h2>7. Children’s Privacy</h2>
        <p>
          Antarctic Press is not intended for children under the age of 13. We do not
          knowingly collect personal information from children.
        </p>
      </section>

      <section>
        <h2>8. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Changes will be
          posted on this page with an updated effective date.
        </p>
      </section>

      <section>
        <h2>9. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy, please contact us
          at:
        </p>
        <p>
          <strong>Email:</strong> <a href="mailto:privacy@antarcticpress.com">privacy@antarcticpress.com</a>
        </p>
      </section>
    </LegalLayout>
  );
}
